/**
 * Magic initData string used by the web `MockPlatformAdapter` and recognised by the API
 * when `DEV_MOCK_AUTH_ENABLED=true`. Must NEVER be accepted in production.
 *
 * Versioning: bump the suffix if the mock user shape changes so old web bundles fail loud
 * instead of silently picking up new fields.
 */
export const DEV_MOCK_INITDATA = 'yadviga_dev_mock_v1';
export const DEV_MOCK_USER_SEED = {
    platformUserId: 'dev_mock_user',
    name: 'Dev Ядвига',
    gender: 'female',
    language: 'ru',
    birthDate: '1995-06-15',
    birthTime: '14:30',
    timezone: 'Europe/Moscow',
};
//# sourceMappingURL=dev-mock.js.map